import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=22fb7e84&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb7e84",
  null
  
)

export default component.exports